export enum OENActivationExpiryMode {
  ACTIVATION,
  EXPIRY,
}
